import { Button } from '@/components/Button';
import DropdownMenu from '@/components/DropdownMenu';
import { faEllipsisVertical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';

export type ActionDropdownOption = {
    name: string;
    onClick: (e: Event) => void;
    children?: ReactNode;
} & Omit<React.ComponentProps<typeof DropdownMenu.Item>, 'onSelect'>;

type ActionDropdownProps = {
    options: ActionDropdownOption[];
};

/**
 * A dropdown menu component that displays a list of actions behind a `...` button.
 */
export const ActionDropdown: React.FC<ActionDropdownProps> = ({ options }) => {
    return (
        <DropdownMenu>
            <DropdownMenu.Trigger>
                <Button
                    className='focus:bg-secondaryButtonBackground focus:ring-secondaryButtonOutline'
                    variant='secondary'
                    icon={<FontAwesomeIcon icon={faEllipsisVertical} className='flex items-center text-xl' />}
                />
            </DropdownMenu.Trigger>

            <DropdownMenu.Menu align='end' className='divide-y divide-dividerPrimary'>
                <DropdownMenu.Group>
                    {options.map(({ name, children, onClick, ...props }) => (
                        <DropdownMenu.Item key={name} onSelect={onClick} {...props}>
                            {children ?? name}
                        </DropdownMenu.Item>
                    ))}
                </DropdownMenu.Group>
            </DropdownMenu.Menu>
        </DropdownMenu>
    );
};
